import { z } from 'zod';

export const libraryItemTypeSchema = z.enum(['REGULATION', 'PASAL', 'NOTE']);

export const libraryItemDetailSchema = z.record(z.unknown());

export const libraryItemSchema = z.object({
  libraryItemId: z.string(),
  userId: z.string(),
  libraryGroupId: z.string().nullable(),
  type: libraryItemTypeSchema,
  title: z.string(),
  detail: libraryItemDetailSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const libraryGroupSchema = z.object({
  libraryGroupId: z.string(),
  userId: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type LibraryItemType = z.infer<typeof libraryItemTypeSchema>;
export type LibraryItemDetail = z.infer<typeof libraryItemDetailSchema>;
export type LibraryItem = z.infer<typeof libraryItemSchema>;
export type LibraryGroup = z.infer<typeof libraryGroupSchema>;

export interface CreateItemInput {
  type: LibraryItemType;
  title: string;
  detail: LibraryItemDetail;
  libraryGroupId?: string | null;
  groupIds?: string[];
  note?: string | null;
}

export interface SavedItemStatus {
  isSaved: boolean;
  libraryItemId?: string;
  libraryGroupId?: string | null;
}

export interface UpdateItemGroupsInput {
  libraryItemId: string;
  groupIds: string[];
}

export interface UpdateNoteInput {
  libraryItemId: string;
  note: string | null;
}

export interface UpdateDetailInput {
  libraryItemId: string;
  detail: Record<string, unknown>;
}
